// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tchf26TsQmemmv {
  position: absolute;
  top: var(--ds-space-0, 0);
  right: var(--ds-space-0, 0);
  bottom: var(--ds-space-0, 0);
  left: var(--ds-space-0, 0);
  border-radius: var(--ds-border-radius-200, 8px);
}
.tchf26TsQmemmv:focus {
  outline: var(--ds-border-focused, #388bff) auto 2px;
  outline-offset: 2px;
}
.mac .tchf26TsQmemmv:focus {
  outline-color: -webkit-focus-ring-color;
}
.tchf26TsQmemmv:focus .mac.firefox {
  outline-color: AccentColor;
}
._VsfBzuz9Pv_iC {
  width: unset;
}
`, ""]);
// Exports
export var boardLink = `tchf26TsQmemmv`;
export var boardCard = `_VsfBzuz9Pv_iC`;
export default ___CSS_LOADER_EXPORT___;
